// extracted by mini-css-extract-plugin
export default {"hostContainer":"w7lEoAwb1r","iframe":"FBQhWHM5FO"};